export const IGNORED_ERRORS = [
  // This happens when the request is aborted by us, e.g. when a user navigates
  // away while a request is still in flight.
  /^AbortError: The user aborted a request.$/,
  /^AbortError: signal is aborted without reason$/,
  // This error seems to happen in Safari if a fetch request fails.
  /^TypeError: Load failed$/,
  /^TypeError: Failed to fetch$/,
  // `path` and `status` belong to the error object that we throw in our
  // server-side request helper
  /^Object captured as exception with keys: path, status$/,
  // `code` and `displayMessage` belong to the error object that we throw in our
  // client-side request helper
  /^Object captured as exception with keys: code, displayMessage$/,
  /^Object captured as exception with keys: message, status$/,
  // Error format is used by the [CefSharp library], a .NET embedded Chromium tool
  // https://trackjs.com/javascript-errors/object-not-found-matching-id-methodname-paramcount/
  /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/,
  // This error seems to be emitted at build time, but nothing seems to be
  // going wrong...
  "Dynamic server usage: Page couldn't be rendered statically because it used `cookies`. See more info here: https://nextjs.org/docs/messages/dynamic-server-error",
];

export const SENTRY_DSN =
  'https://4e2ea2dfcf5a6028077df840cc6c50ac@o501609.ingest.us.sentry.io/4508638068146176';
